
import axios from 'axios';

import {
  defineComponent,
  ref,
  onMounted,
} from 'vue';

import type {
  EntriesPaginator,
  Pseudosites,
} from '@/types';

import {
  TRAFFIC_CATEGORIES,
  TRAFFIC_CATEGORIES_MAP,
  ENTRIES,
} from '@/libs/consts';

import useUser from '@/composable/useUser';

import useEntries from '@/composable/useEntries';

import useUrlState from '@/composable/useUrlState';

export default defineComponent({
  setup() {
    const { activeUser: user } = useUser();

    const {
      entriesLoading: projectsLoading,
      entries: projects,
      fetchEntries: fetchProjects,
    } = useEntries();

    const pseudosites = ref<Pseudosites>({ ...ENTRIES });

    const pseudositesFilters = useUrlState('filters', {
      project_id: null,
      host: null,
      traffic_category: null,
    });

    const fetchPseudosites = async (pseudositesPaginator: EntriesPaginator): Promise<void> => {
      const response = await axios.post(
        '/api/pseudosite/getPseudositesPaginator',
        {
          ...pseudositesPaginator,
          ...pseudositesFilters,
        },
      );

      pseudosites.value = response.data as Pseudosites;
    };

    onMounted((): void => {
      Promise.all([
        user.isSuperAdmin() ? fetchProjects('/api/project/getProjects') : Promise.resolve(),
      ]);
    });

    return {
      TRAFFIC_CATEGORIES,
      TRAFFIC_CATEGORIES_MAP,
      user,
      projectsLoading,
      projects,
      pseudosites,
      pseudositesFilters,
      fetchPseudosites,
    };
  },
});
